import { render, staticRenderFns } from "./ReportedUser.vue?vue&type=template&id=005be8fe&scoped=true&"
import script from "./ReportedUser.vue?vue&type=script&lang=js&"
export * from "./ReportedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005be8fe",
  null
  
)

export default component.exports